// extracted by mini-css-extract-plugin
module.exports = {"scrollableContent":"program-stat_scrollableContent_Yq2ak","message":"program-stat_message_32849","notScrollableContent":"program-stat_notScrollableContent_CmXYN"};